import React from 'react';
import { useTranslation } from 'react-i18next';
import { TooltipedInfoIcon } from '../../../../ui-kit';

interface RemoveWarehouseCategoryTitleProps {
    warehouseCategoryName: string;
}

const RemoveWarehouseCategoryTitle = ({ warehouseCategoryName }: RemoveWarehouseCategoryTitleProps) => {
    const { t } = useTranslation();
    return (
        <>
            {t('Remove {{name}}', { name: warehouseCategoryName })}
            <TooltipedInfoIcon
                tooltipFontSize='1rem'
                tooltip={t('You can only delete a warehouse category if there are no warehouse cards assigned to it') as string}
            />
        </>
    );
};

export default RemoveWarehouseCategoryTitle;
